import { motion } from "framer-motion";

const stats = [
  { value: "22+", label: "Years Development & Construction Leadership", testid: "capability-stat-leadership" },
  { value: "23", label: "Years Concrete & Field Construction Experience", testid: "capability-stat-field" },
  { value: "Kansas City", label: "Based — Residential | Commercial | Multifamily | Development", testid: "capability-stat-location" },
];

const delivery = [
  "Preconstruction",
  "Estimating",
  "Scheduling",
  "Procurement",
  "Subcontractor Management",
  "Construction Management",
  "Site Development",
  "Quality Control",
  "Closeout",
];

export default function Capabilities() {
  return (
    <section id="capabilities" className="relative py-24 lg:py-32 border-t border-[#D4AF37]/10 bg-[#080808]" data-testid="capabilities-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-8"
          data-testid="capabilities-section-overline"
        >
          Corporate Capabilities
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-[#F5F5F5] mb-16 lg:mb-20"
          data-testid="capabilities-headline"
        >
          Built to deliver.
          <br />
          <span className="italic text-[#D4AF37]">At any scale.</span>
        </motion.h2>

        <div className="grid sm:grid-cols-3 gap-10 lg:gap-14 mb-16 lg:mb-20" data-testid="capabilities-stats">
          {stats.map((s, i) => (
            <motion.div
              key={s.testid}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12 }}
              className="border-l border-[#D4AF37]/30 pl-6"
              data-testid={s.testid}
            >
              <p className="font-display text-4xl sm:text-5xl text-[#D4AF37]">{s.value}</p>
              <p className="mt-3 text-[10px] tracking-[0.25em] uppercase text-[#A3A3A3] leading-relaxed">{s.label}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9 }}
        >
          <p className="text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-8" data-testid="delivery-overline">
            Delivery Capabilities
          </p>
          <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-4" data-testid="delivery-capabilities">
            {delivery.map((d) => (
              <li key={d} className="flex items-baseline gap-3.5 text-sm font-light tracking-[0.15em] uppercase text-[#F5F5F5]/85">
                <span className="w-1.5 h-1.5 rotate-45 bg-[#D4AF37] shrink-0" aria-hidden="true" />
                {d}
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
